<template>
	<div class="socials">
		<a
			v-for="medium in socials"
			:key="medium.ID"
			:class="medium.platform"
			:aria-label="medium.platform"
			:href="medium.url"
			target="_blank"
		>
			<font-awesome-icon v-if="medium.platform == 'twitter'" icon="fa-brands fa-x-twitter" size="1x" />
			<font-awesome-icon
				v-else-if="!['tripadvisor', 'zoover'].includes(medium.platform)"
				:icon="`fa-brands fa-${medium.platform}`"
				size="1x"
			/>
		</a>
	</div>
</template>

<script setup>
defineProps({
	socials: { type: Array, default: () => [] },
});
</script>

<style lang="scss" scoped>
.socials .tripadvisor {
	background: url('~/assets/images/tripadvisor-small-white.png') no-repeat center center #000;
	background-size: 22px;
	width: 40px;
	height: 40px;
}

.socials .tripadvisor:hover {
	background: url('~/assets/images/tripadvisor-small-white.png') no-repeat center center #dd4949;
	background-size: 22px;
}

.socials {
	display: flex;
	flex-flow: row wrap;
	align-items: flex-start;

	a {
		width: 40px;
		height: 40px;
		line-height: 40px;
		background: $cta-color;
		text-align: center;
		font-size: 16px;
		text-decoration: none;
		color: #fff;
		display: inline-block;
		margin: 5px 5px 5px 0;
		border-radius: 50%;

		&:hover {
			color: #fff;
			background: $cta-color-hover;
		}
	}
}
</style>
